<template>
  <span v-show="true">
  <div>
    <button class="actions_btn actions_btn_v2" >Actions</button>
    <div class="menu_list_wrap menu_v2">
      <VuePerfectScrollbar>
        <div class="menu_list">
          <template  v-for="(menuItem, index) in menuItems">
            <div v-if="checkActionRequired(menuItem,index)" @click="triggerAction(menuItem)" class="menu_item drop_menu_items" :key="index" :itemCode="menuItem['code']">
              <a v-if="checkProperty(menuItem, 'code') == 'EDIT_QUESTIONNAIRE'">{{ checkProperty(caseDetails, 'questionnaireFilled')?menuItem['actionLable']:'Fill Questionnaire' }}</a>
              <a v-else>{{ menuItem['actionLable'] }}</a>
              </div>
          </template> 
        </div>
      </VuePerfectScrollbar>
    </div>
    <actionsPopup ref="actionsPopupform" :caseDetails="caseDetails" @updatepetition="updatepetition"/>
  </div>
</span>        
</template>

      
<script>
import actionsPopup from "@/views/i-9Module/actionsFlow/actionsPopup.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  inject: ["parentValidator"],
  created() {
      this.$validator = this.parentValidator;
  },
  components: {
    actionsPopup,
    VuePerfectScrollbar
  },
  data() {
    return {
      showMe:false,
      menuItems: [
        {
          code: "CASE_APPROVE",
          name: "CASE APPROVE",
          actionLable: "Approve",
        },
        {
          code: "CASE_REJECT",
          name: "CASE REJECT",
          actionLable: "Reject",
        },
        {
          code: "EDIT_QUESTIONNAIRE",
          name: "Edit Questionnaire",
          actionLable: "Edit Questionnaire",
        },
        {
          code: "E-VERIFY",
          name: "E-Verify",
          actionLable: "E-Verify",
        },
        
      ],
    };
  },
  methods: {
    checkActionRequired(item,index){
      var $self = this;
      if(index == (this.menuItems.length-1)){
            setTimeout(function(){
                if(document.getElementsByClassName("drop_menu_items").length > 0){
                    $self.showMe = true;
                }
            },100)
        }
      switch (item.code) {
        case "CASE_APPROVE":
        if((([50].indexOf(this.getUserRoleId)>-1&&this.getTenantTypeId != 2)||(this.getTenantTypeId == 2&&[3,4].indexOf(this.getUserRoleId)>-1))&&(this.checkProperty(this.caseDetails, 'completedActivities', 'length') > 0
        &&this.caseDetails.completedActivities.indexOf('WAITING_FOR_EMPLOYEE_SIGN') >-1||this.checkProperty(this.caseDetails, 'questionnaireFilled'))
        &&(this.caseDetails.completedActivities.indexOf('APPROVED') <=-1 || [10].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))<=-1)
        &&(this.caseDetails.completedActivities.indexOf('REJECTED') <=-1 || [10].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))<=-1)) return true
          return false
          break;
        case "CASE_REJECT":
        if((([50].indexOf(this.getUserRoleId)>-1&&this.getTenantTypeId != 2)||(this.getTenantTypeId == 2&&[3,4].indexOf(this.getUserRoleId)>-1))&&(this.checkProperty(this.caseDetails, 'completedActivities', 'length') > 0
        &&this.caseDetails.completedActivities.indexOf('WAITING_FOR_EMPLOYEE_SIGN') >-1||this.checkProperty(this.caseDetails, 'questionnaireFilled'))
        &&(this.caseDetails.completedActivities.indexOf('APPROVED') <=-1|| [5].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))<=-1)
        &&(this.caseDetails.completedActivities.indexOf('REJECTED') <=-1 || [5].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))<=-1)) return true
        return false
          break;
        case "EDIT_QUESTIONNAIRE":
          if([51].indexOf(this.getUserRoleId)>-1 && 
          (!this.checkProperty(this.caseDetails, 'questionnaireFilled') || (this.checkProperty(this.caseDetails, 'questionnaireFilled') && (this.caseDetails.completedActivities.indexOf('REJECTED') >-1 || this.caseDetails.completedActivities.indexOf('VERIFIER_REJECTED')>-1)) && this.checkProperty(this.caseDetails, 'statusDetails', 'id') == 10)
          ) return true
          return false
          break;
          // case "E-VERIFY":
          // if([3,4,5,6,8,7].indexOf(this.getUserRoleId)>-1 &&
          // ([9].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))>-1)
          // ) return true
          // return false
          // break;
        default:   
          return false
        }
    },

    triggerAction(menuItem) {
      switch (menuItem.code) {
        case "EDIT_QUESTIONNAIRE":
          let petitionId = this.checkProperty(this.caseDetails, '_id')
          this.$router.push("/I9-questionnaire/"+petitionId);
        break;
        case "CASE_APPROVE":
          this.$refs['actionsPopupform'].openApproveOrRejectModal("CASE_APPROVE");
        break;
        case "CASE_REJECT":
        this.$refs["actionsPopupform"].openApproveOrRejectModal("CASE_REJECT");
        case "E-VERIFY":
        this.$refs["actionsPopupform"].openApproveOrRejectModal("E-VERIFY");
        break;
        default:
        return false
      }
    },
    updatepetition(){
      this.$emit("updatepetition", "Case Details");
    },
  },
  mounted(){
  },
  props:{
    caseDetails: {
        type: Object,
        default: null,
      },
  }
};
</script>
      
      